// import { IResourceComponentsProps } from "@refinedev/core";
// import { MuiListInferencer } from "@refinedev/inferencer/mui";

// export const PurshaseList: React.FC<IResourceComponentsProps> = () => {
//   return (
//     <MuiListInferencer
//       fieldTransformer={(field: any) => {
//         // if (["locale", "updatedAt", "publishedAt"].includes(field.key)) {
//         //   return false;
//         // }

//         return field;
//       }}
//     />
//   );
// };

import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useMany } from "@refinedev/core";
import {
  DateField,
  EditButton,
  List,
  ShowButton,
  useDataGrid,
} from "@refinedev/mui";
import React from "react";

export const PurshaseList = () => {
  const { dataGridProps } = useDataGrid();

  const { data: containerData, isLoading: containerIsLoading } = useMany({
    resource: "containers",
    ids: dataGridProps?.rows?.map((item: any) => item?.container) ?? [],
    queryOptions: {
      enabled: !!dataGridProps?.rows,
    },
  });

  const columns = React.useMemo<GridColDef<any>[]>(
    () => [
      {
        field: "quantity",
        headerName: "Quantity",
        type: "number",
      },
      {
        field: "source",
        headerName: "Source",
      },
      {
        field: "prix",
        headerName: "Prix",
        type: "number",
      },
      {
        field: "total",
        headerName: "Total",
        type: "number",
      },
      {
        field: "avance",
        headerName: "Avance",
        type: "number",
      },
      {
        field: "reste",
        headerName: "Reste",
        type: "number",
      },
      {
        field: "container",
        headerName: "Container",
        minWidth: 300,
        renderCell: function render({ value }) {
          return containerIsLoading ? (
            <>Loading...</>
          ) : (
            containerData?.data?.find((item) => item.id === value?.id)?.name ??
              "Container unknowed"
          );
        },
      },
      {
        field: "createdAt",
        headerName: "Created At",
        minWidth: 250,
        renderCell: function render({ value }) {
          return <DateField value={value} />;
        },
      },
      {
        field: "actions",
        headerName: "Actions",
        renderCell: function render({ row }) {
          return (
            <>
              <EditButton hideText recordItemId={row.id} />
              <ShowButton hideText recordItemId={row.id} />
            </>
          );
        },
        align: "center",
        headerAlign: "center",
        minWidth: 80,
      },
    ],
    [containerData?.data]
  );

  return (
    <List>
      <DataGrid {...dataGridProps} columns={columns} autoHeight />
    </List>
  );
};
